import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import cn from 'classnames';
import cd from 'debug';

import globalMessages from 'messages';
import type { Analytics } from 'services/analytics';
import Icon from '../Icon';
import SmartLink from '../SmartLink';

import arrowLeft from 'assets/svg/arrow-left.svg';
import playSmall from 'assets/svg/play-arrow.svg';
import './streamLink.scss';

const debug = cd('components:Score');

interface Props {
    linkToMatch: string | null;
    withTitle?: boolean;
    onClick?: () => void;
    isViewerOpen?: boolean;
    analytics?: Analytics;
}

const StreamLink: React.FC<Props> = props => {
    debug('render', props);

    const { withTitle, linkToMatch, isViewerOpen, analytics } = props;
    const { formatMessage } = useIntl();

    if (typeof props.onClick === 'function') {
        return (
            <div
                styleName={cn('container', {
                    'with-title': withTitle,
                    'is-open': isViewerOpen,
                })}
                className="__app-StreamLink-container"
                data-category={analytics?.category}
                data-action={analytics?.action}
                onClick={props.onClick}
                title={formatMessage(globalMessages.watch)}
            >
                <Icon
                    styleName="icon"
                    glyph={isViewerOpen ? arrowLeft : playSmall}
                />
                {withTitle && (
                    <FormattedMessage
                        {...(isViewerOpen
                            ? globalMessages.hide
                            : globalMessages.watch)}
                    />
                )}
            </div>
        );
    }

    return (
        <SmartLink
            styleName={cn('container', { 'with-title': withTitle })}
            className="__app-StreamLink-container"
            to={linkToMatch}
            title={formatMessage(globalMessages.watch)}
        >
            <Icon styleName="icon" glyph={playSmall} />
            {withTitle && <FormattedMessage {...globalMessages.watch} />}
        </SmartLink>
    );
};

export default StreamLink;
